import { useEffect } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { SellMyApartmentHero } from './components/SellMyApartmentHero';
import { HowToSellApartmentBuilding } from './components/HowToSellApartmentBuilding';
import { INeedToSellMyApartments } from './components/INeedToSellMyApartments';
import { SellApartmentsWithTenants } from './components/SellApartmentsWithTenants';
import { SellVacantApartmentComplex } from './components/SellVacantApartmentComplex';
import { SellMyApartmentsForCash } from './components/SellMyApartmentsForCash';
import { SellMyApartmentsFast } from './components/SellMyApartmentsFast';
import { SellMyApartmentAsIs } from './components/SellMyApartmentAsIs';
import { SellMyApartmentToInvestors } from './components/SellMyApartmentToInvestors';
import { SellMyApartmentFinalCTA } from './components/SellMyApartmentFinalCTA';

export default function SellMyApartmentBuilding() {
  useEffect(() => {
    // Set document title
    document.title = 'Sell My Apartment Building Fast for Cash - Get Fair Offers Today';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Need to sell your apartment building? Get cash offers in 24 hours. We buy apartments with tenants, vacant complexes, and distressed properties. Sell my apartments fast, fair, and hassle-free nationwide.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Need to sell your apartment building? Get cash offers in 24 hours. We buy apartments with tenants, vacant complexes, and distressed properties. Sell my apartments fast, fair, and hassle-free nationwide.';
      document.head.appendChild(meta);
    }

    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'sell my apartment building, sell my apartments, sell apartments with tenants, sell vacant apartment complex, sell my apartments for cash, sell my apartments fast, sell apartment as-is, sell apartment to investors');
    } else {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', 'sell my apartment building, sell my apartments, sell apartments with tenants, sell vacant apartment complex, sell my apartments for cash, sell my apartments fast, sell apartment as-is, sell apartment to investors');
      document.head.appendChild(metaKeywords);
    }

    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://sellapartmentscash.com/sell-my-apartment-building');
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', 'https://sellapartmentscash.com/sell-my-apartment-building');
      document.head.appendChild(canonical);
    }

    // Add structured data for FAQ
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "How do I sell my apartment building quickly?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The fastest way to sell your apartment building is to work with a direct cash buyer like us. We can close in 7-30 days, skip traditional financing delays, and buy your property in any condition."
          }
        },
        {
          "@type": "Question",
          "name": "Can I sell my apartments with tenants still living there?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we regularly buy apartment buildings with existing tenants. We handle all tenant communications and lease transfers, making the process seamless for both you and your tenants."
          }
        },
        {
          "@type": "Question",
          "name": "What if my apartment building needs major repairs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We buy apartment buildings in any condition, including those needing significant repairs. You don't need to fix anything - we'll handle all necessary improvements after closing."
          }
        },
        {
          "@type": "Question",
          "name": "How much is my apartment building worth?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We provide free, no-obligation property valuations based on current market conditions, rental income, expenses, and property condition. Contact us for a personalized cash offer."
          }
        },
        {
          "@type": "Question",
          "name": "Should I sell my apartment building AS IS or remodel first?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Most apartment building owners save more money by selling AS IS. Renovations typically cost $500K-$2M+ and take 12-18 months, but often don't increase property value enough to justify the investment. Learn more about AS IS vs remodeling to make the best decision."
          }
        }
      ]
    };

    // Add structured data script
    let structuredDataScript = document.querySelector('script[type="application/ld+json"]');
    if (structuredDataScript) {
      structuredDataScript.textContent = JSON.stringify(structuredData);
    } else {
      structuredDataScript = document.createElement('script');
      structuredDataScript.type = 'application/ld+json';
      structuredDataScript.textContent = JSON.stringify(structuredData);
      document.head.appendChild(structuredDataScript);
    }

    // Cleanup function
    return () => {
      const elementsToRemove = [
        document.querySelector('meta[name="description"]'),
        document.querySelector('meta[name="keywords"]'),
        document.querySelector('link[rel="canonical"]'),
        document.querySelector('script[type="application/ld+json"]')
      ].filter(element => {
        if (!element) return false;
        const content = element.getAttribute('content') || element.getAttribute('href') || element.textContent || '';
        return content.includes('sell my apartment') || content.includes('sell-my-apartment-building');
      });
      
      elementsToRemove.forEach(element => element?.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans">
      <Header />
      <main>
        <SellMyApartmentHero />
        <HowToSellApartmentBuilding />
        <INeedToSellMyApartments />
        <SellApartmentsWithTenants />
        <SellVacantApartmentComplex />
        <SellMyApartmentsForCash />
        <SellMyApartmentsFast />
        <SellMyApartmentAsIs />
        <SellMyApartmentToInvestors />
        <SellMyApartmentFinalCTA />
      </main>
      <Footer />
    </div>
  );
}